import * as fflate from 'fflate'
import { log } from '#utils/logger'

import { cosimaLexing } from './lexer'
import { parseXml } from './parser'
import { type EnhancedCosimaRoot, enhanceCosimaRoot } from './util'

// ie: 02822GN-e5f36f689e0775230aca00187a6e18c5-de-DE.xml
//     ^^^^^^^ product code
//             ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ document hash
//                                              ^^^^^ language
const fragmentRegex = /(?<code>[a-zA-Z0-9]{6,7})-(?<id>[a-fA-F0-9]{32})-(?<language>[a-z]{2}-[A-Z]{2}).xml/

interface DocumentEntry {
  code: string
  id: string
  languages: Record<string, EnhancedCosimaRoot>
}
export const CosimaDocuments = {} as Partial<Record<string, DocumentEntry>>

export const CosimaDocumentArray: DocumentEntry[] = []

void (async () => {
  // assuming the module initialized already
  if (Object.keys(CosimaDocuments).length > 0) {
    return
  }

  const request = await fetch('/cosima/xml.zip')
  if (!request.ok) {
    return
  }
  // preparing the zip to be read
  const buffer = await request.arrayBuffer()
  const uint8Array = new Uint8Array(buffer)
  const entries = fflate.unzipSync(uint8Array)

  // the keys are document URIs: `my/folder/document.xml`
  for (const key of Object.keys(entries)) {
    const nameGroups = fragmentRegex.exec(key)?.groups as { code: string; id: string; language: string } | undefined
    if (!nameGroups) {
      log.warn(`could not parse document name of '${key}'`)
      continue
    }

    const { code, id, language } = nameGroups
    const value = entries[key]
    // apparently very fast U8 to string converter
    const text = fflate.strFromU8(value)

    try {
      const document = parseXml(text)
      const lexerResult = cosimaLexing(document)
      if (!lexerResult) {
        log.warn(`Lexer returned no result for document: ${key}`)
        continue
      }

      const enhancedDocument = enhanceCosimaRoot(lexerResult)
      if (CosimaDocuments[code]) {
        // create a new entry
        CosimaDocuments[code].languages[language] = enhancedDocument
      } else {
        // update the existing entry with another language
        CosimaDocuments[code] = { code, id, languages: { [language]: enhancedDocument } }
      }
    } catch (e) {
      log.error('Error while parsing:', e)
    }
  }

  // update the array for easy access (primarily for hashing a random option)
  CosimaDocumentArray.length = 0
  CosimaDocumentArray.push(...Object.values(CosimaDocuments).filter((x) => !!x))
})()
